import React, { useState } from 'react'
import styles from '../reportSection.module.scss';
import { Accordion, AccordionDetails, AccordionSummary, Card, Grid, Typography } from '@mui/material'
import {CustomDownIcon, CustomUpIcon} from '../../common/StyledComponents/StyledFields';
import PoojaBooking from './poojaBooking';
import DailyReport from './dailyReport';
import PoojaBookingReport from './poojabookingReport';
import PoojaBookingSummary from './poojaBookingSummary';
import SummaryBySignInName from './summaryBySignInName';

const PoojaReports = () => {
  const [isAccordionExpanded, setAccordionExpanded] = useState(false);
  const [isDailyReport, setDailyReport] = useState(false);
  const [isBookingReport, setBookingReport] = useState(false);
  const [isSummary, setSummary] = useState(false);
  const [isSignInName, setSignInName] = useState(false);

  const handleToggleChange = (flag: any) => {
    switch (flag) {
      case 'accordion':
        setAccordionExpanded((prevExpanded) => !prevExpanded);
        break;
      case 'dailyReport':
        setDailyReport((prevExpanded) => !prevExpanded);
        break;
      case 'bookingReport':
        setBookingReport((prevExpanded) => !prevExpanded);
        break;
      case 'summary':
        setSummary((prevExpanded) => !prevExpanded);
        break;
      case 'signInName':
        setSignInName((prevExpanded) => !prevExpanded);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className={styles.poojareportsLayout}>
        <Typography className={styles.typoGraphyHeader}>
          PoojaReports
        </Typography>
        <Card className={styles.cardContainer}>
          <Grid sx={{ mt: 2 }}>
            <Accordion
              sx={{
                border: isAccordionExpanded ? '1px solid #F05802' : '1px solid #989898',
                background: '#FFF9E4',
                boxShadow: "none", borderRadius: "8px"
              }}
              expanded={isAccordionExpanded}
              onChange={() => handleToggleChange('accordion')}
            >
              <AccordionSummary
                aria-controls={`panel-content`}
                id={`panel--header`}
              >
                <Grid container>
                  <Grid item className={styles.iconstyles}>
                    {isAccordionExpanded ? (
                      <CustomUpIcon />
                    ) : (
                      <CustomDownIcon />
                    )}
                  </Grid>
                  <Grid item>
                    <Typography variant="subtitle1" className={styles.typoGraphyHeading}>Pooja Booking</Typography>
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                <PoojaBooking />
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid sx={{ mt: 2 }}>
            <Accordion
              sx={{
                border: isDailyReport ? '1px solid #F05802' : '1px solid #989898',
                background: '#FFF9E4',
                boxShadow: "none", borderRadius: "8px"
              }}
              expanded={isDailyReport}
              onChange={() => handleToggleChange('dailyReport')}
            >
              <AccordionSummary
                aria-controls={`panel-content`}
                id={`panel--header`}
              >
                <Grid container>
                  <Grid item className={styles.iconstyles}>
                    {isDailyReport ? (
                      <CustomUpIcon />
                    ) : (
                      <CustomDownIcon />
                    )}
                  </Grid>
                  <Grid item>
                    <Typography variant="subtitle1" className={styles.typoGraphyHeading}>Pooja Booking Daily Report </Typography>
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                <DailyReport />
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid sx={{ mt: 2 }}>
            <Accordion
              sx={{
                border: isBookingReport ? '1px solid #F05802' : '1px solid #989898',
                background: '#FFF9E4',
                boxShadow: "none", borderRadius: "8px"
              }}
              expanded={isBookingReport}
              onChange={() => handleToggleChange('bookingReport')}
            >
              <AccordionSummary
                aria-controls={`panel-content`}
                id={`panel--header`}
              >
                <Grid container>
                  <Grid item className={styles.iconstyles}>
                    {isBookingReport ? (
                      <CustomUpIcon />
                    ) : (
                      <CustomDownIcon />
                    )}
                  </Grid>
                  <Grid item>
                    <Typography variant="subtitle1" className={styles.typoGraphyHeading}>Pooja Booking Report </Typography>
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
               <PoojaBookingReport/>
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid sx={{ mt: 2 }}>
            <Accordion
              sx={{
                border: isSummary ? '1px solid #F05802' : '1px solid #989898',
                background: '#FFF9E4',
                boxShadow: "none", borderRadius: "8px"
              }}
              expanded={isSummary}
              onChange={() => handleToggleChange('summary')}
            >
              <AccordionSummary
                aria-controls={`panel-content`}
                id={`panel--header`}
              >
                <Grid container>
                  <Grid item className={styles.iconstyles}>
                    {isSummary ? (
                      <CustomUpIcon />
                    ) : (
                      <CustomDownIcon />
                    )}
                  </Grid>
                  <Grid item>
                    <Typography variant="subtitle1" className={styles.typoGraphyHeading}>Pooja Booking Summary </Typography>
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>

               <PoojaBookingSummary/>
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid sx={{ mt: 2 }}>
            <Accordion
              sx={{
                border: isSignInName ? '1px solid #F05802' : '1px solid #989898',
                background: '#FFF9E4',
                boxShadow: "none", borderRadius: "8px"
              }}
              expanded={isSignInName}
              onChange={() => handleToggleChange('signInName')}
            >
              <AccordionSummary
                aria-controls={`panel-content`}
                id={`panel--header`}
              >
                <Grid container>
                  <Grid item className={styles.iconstyles}>
                    {isSignInName ? (
                      <CustomUpIcon />
                    ) : (
                      <CustomDownIcon />
                    )}
                  </Grid>
                  <Grid item>
                    <Typography variant="subtitle1" className={styles.typoGraphyHeading}>Pooja Booking Summary by Sign-In Name</Typography>
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
               <SummaryBySignInName/>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Card>
      </div>
    </>

  )
}

export default PoojaReports